import styled from '@emotion/styled'
import * as Popover from '@radix-ui/react-popover'
import { ReactNode } from 'react'

import { theme } from '../../../constants'
import { Button, ButtonProps } from '../../Button'
import { panelAnimation, panelStyles } from '../styles'

const Content = styled(Popover.Content)({
  ...panelStyles,
  ...panelAnimation,
  minWidth: 290,
  padding: theme.spacing['2.5'],
  zIndex: theme.zIndex.popover,
})

type PopoverButtonProps = ButtonProps & {
  buttonLabel: ReactNode
  children: ReactNode
  align?: 'center' | 'end' | 'start'
}

export const PopoverButton = ({
  children,
  buttonLabel,
  align,
  ...buttonProps
}: PopoverButtonProps) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <Button {...buttonProps}>{buttonLabel}</Button>
      </Popover.Trigger>
      <Content sideOffset={5} align={align}>
        {children}
      </Content>
    </Popover.Root>
  )
}
